import clsx from 'clsx'
import BookingLink from './booking-link'
import { Sparkles } from 'lucide-react'
import { usePageTheme } from '@/components/page-theme-provider'
import { getButtonGradientClass } from '@/utils/service-theme'

const BookButtonStatic = ({
  color,
  text,
  link,
  custom,
  icon,
  left,
  right,
  onClick,
  iconColor,
  ariaLabel,
}) => {
  const pageTheme = usePageTheme()
  const effectiveColor = color || pageTheme.key
  const isGhost = effectiveColor === 'ghost'
  const gradientClass = getButtonGradientClass(effectiveColor)

  return (
    <BookingLink
      href={link ? link : '/contact-us'}
      aria-label={ariaLabel || text || 'Book an appointment'}
    >
      <div
        {...(onClick ? { onClick } : {})}
        className={clsx(
          'relative mx-auto flex items-center justify-center gap-2.5 overflow-hidden rounded-full px-5 py-3 font-bold active:top-px whitespace-nowrap',
          isGhost
            ? 'bg-transparent text-black transition-colors duration-150 hover:bg-gray-100'
            : 'bg-gradient-to-br text-white',
          gradientClass,
          custom || '',
        )}
      >
        <span
          className={clsx(
            'flex items-center gap-2.5 whitespace-nowrap [&_svg]:pointer-events-none [&_svg]:size-4 [&_svg]:shrink-0',
            effectiveColor !== 'white' && effectiveColor !== 'ghost' && '',
          )}
        >
          {left && !right && icon ? icon : null}
          {!left && !right ? <Sparkles className={clsx(iconColor && iconColor)} /> : null}
          {text ? text : 'Book an Appointment'}
          <span className={iconColor ? iconColor : ''}>{right && icon ? icon : null}</span>
        </span>
      </div>
    </BookingLink>
  )
}

export default BookButtonStatic
